<template>
  <path
    d="M20 3.00018H19V2.00018C19 1.45018 18.55 1.00018 18 1.00018C17.45 1.00018 17 1.45018 17 2.00018V3.00018H7V2.00018C7 1.45018 6.55 1.00018 6 1.00018C5.45 1.00018 5 1.45018 5 2.00018V3.00018H4C2.9 3.00018 2 3.90018 2 5.00018V21.0002C2 22.1002 2.9 23.0002 4 23.0002H20C21.1 23.0002 22 22.1002 22 21.0002V5.00018C22 3.90018 21.1 3.00018 20 3.00018ZM19 21.0002H5C4.45 21.0002 4 20.5502 4 20.0002V8.00018H20V20.0002C20 20.5502 19.55 21.0002 19 21.0002Z"
  />
</template>
